<template>
        <form class="user-location">
            <v-select class=" user-location__select jlr-select"
                      :value.sync="userLocation"
                      :options="limitedСitiesList || cities"
                      :getOptionLabel="getOptionLabel"
                      label="description"
                      :placeholder="$t('common.userLocationDescription')"
                      :on-search="getCities"
                      :on-change="changeUserLocation">
                <div slot="selected-option">
                    {{ userLocationCity }}
                </div>
                <div class="user-location__loading"  slot="spinner">
                     <img class="user-location__spinner" src="../icons/loaders_icon.gif">
                </div>
                <div slot="no-options"
                     class="no-items"
                     :class="{'_empty-search': emptySearch}">
                    {{ $t('common.noCities') }}
                </div>
            </v-select>
        </form>
</template>

<script>
    import ModalWindow from './ModalWindow.vue';
    import vSelect from 'vue-select'
    import axios from 'axios';
    import { mapMutations } from 'vuex';
    import { cookieHelper } from '../cookieHelper';

    export default {
        name: 'UserLocation',
        props: {
            limitedСitiesList: {
                type: Array,
                default: function () {
                    return null;
                }
            }
        },
        data(){
            return {
                userLocation: '',
                userLocationCookie: null,
                userCoords: {
                    lat: null,
                    lng: null
                },
                cities: [],
                emptySearch: true
            }
        },

        computed: {
            userLocationCity() {
                if(typeof(this.userLocation.description) === 'string') {
                    return this.userLocation.description.split(',')[0];
                } else {
                    return null;
                }
            }
        },

        methods: {
            ...mapMutations([
                'setUserLocation',
                'setUserCoords'
            ]),
            changeUserLocation(val) {
                if (val) {
                    this.userLocation = val;
                    if( this.userLocation !== cookieHelper.get('USER_LOCATION')) {
                        this.setUserLocation(this.userLocation);
                        cookieHelper.set('USER_LOCATION', JSON.stringify(this.userLocation));
                        this.$emit('changeUserLocation', this.userLocation);

                        this.setUserCoords(this.userCoords);
                        if(this.userCoords.lat) {
                            this.userCoords = {
                                lat: null,
                                lng: null
                            };
                        }
                    }
                } else {
                    this.$emit('changeUserLocation', null);
                }
            },
            getCities(search, loading) {
                this.emptySearch = !search;

                if(this.limitedСitiesList) {
                    return null;
                }
                loading(true);
                const autocomplete = new google.maps.places.AutocompleteService;
                autocomplete.getPlacePredictions(
                    {
                        input: search,
                        types: ['(cities)'],
                        componentRestrictions: {country: ['RU', 'BY', 'KZ', 'AM']}
                    },
                    res => {
                        if(res) {
                            this.cities = res;
                        } else {
                            this.cities = [];
                        }

                        loading(false);
                    })
            },

            preliminaryСhoice() {
                if(this.limitedСitiesList.length === 1) {
                    this.userLocation = this.limitedСitiesList[0];
                    this.$emit('changeUserLocation', this.userLocation)
                } else if (this.userLocationCookie) {
                    const userLocationObject = JSON.parse(this.userLocationCookie);
                    this.limitedСitiesList.forEach(city => {
                        if (userLocationObject.city_id === city.city_id || userLocationObject.place_id === city.place_id) {
                            this.userLocation = city;
                            this.$emit('changeUserLocation', this.userLocation)
                        }
                    })
                } else if (navigator.geolocation){
                    const self = this;
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            self.userCoords = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };

                            self.$store.dispatch('searchUserCity', self.userCoords)
                                .then((res) => {
                                    self.limitedСitiesList.forEach(city => {
                                        if (res.place_id === city.place_id) {
                                            self.userLocation = city;
                                            self.$emit('changeUserLocation', this.userLocation)
                                        }
                                    })
                                })
                        }
                    )
                }
            },

            unlimitedPreliminaryChoice() {
                if(this.userLocationCookie) {
                    const userLocationObject = JSON.parse(this.userLocationCookie);
                    this.setUserLocation(userLocationObject);
                    this.userLocation = userLocationObject;
                    this.$emit('changeUserLocation', this.userLocation)
                } else {
                    if(navigator.geolocation) {
                        const self = this;
                        navigator.geolocation.getCurrentPosition(
                            function(position){
                                self.userCoords = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                };

                                self.$store.dispatch('searchUserCity', self.userCoords)
                                    .then((res)=> {
                                        self.userLocation = res;
                                    })
                            },
                            function(error){
                                console.log('It was not possible to determine the position. Errors: \n', error)
                            }
                        )
                    }
                }
            },

            getOptionLabel(option) {
                return option.description;
            }
        },

        beforeMount() {
            this.userLocationCookie = cookieHelper.get('USER_LOCATION');

            if(this.limitedСitiesList) {
                this.preliminaryСhoice();
            } else {
                this.unlimitedPreliminaryChoice();
            }

        },
        components: {
            vSelect
        }
    }
</script>

<style lang="less">
    @import (less) "../styles/colors.less";

    .user-location {
        text-align: left;

        &__select {
            &.v-select {
                display: inline-block;
                position: relative;
                height: 40px;

                &::after {
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    content: '';
                    display: block;
                    width: 55px;
                    height: calc(~'100% - 2px');
                    background: url('../icons/geo_position.svg') no-repeat 80%, linear-gradient(to left, white 50%, @transparent) !important;
                }

                .dropdown-toggle {
                    border: none !important;
                    border-radius: 0;
                    background: white;
                    text-transform: uppercase;
                    position: relative;
                    overflow: hidden;
                    height: 40px;
                }

                .form-control {
                    padding: 0 10px !important;
                    position: absolute;
                    left: 0;
                    width: 100% !important;
                    text-transform: uppercase !important;
                }

                .selected-tag {
                    white-space: nowrap;
                    text-transform: uppercase;
                    line-height: 40px;
                }

                .dropdown-menu {
                    border: none;
                    border-radius: 0;
                    padding: 0;

                    li {
                        border-top: 1px solid lightgrey;

                        a {
                            white-space: normal;
                            width: 100%;
                            display: block;
                            padding-left: 10px;
                        }
                    }
                }

                .open-indicator {
                    display: none;
                }
            }


            &.loading {
                .user-location__loading {
                    opacity: 1;
                }
            }
        }

        &__loading{
            position: absolute;
            right: 4px;
            z-index: 200;
            background: white;
            height: 40px;
            width: 40px;
            opacity: 0;
            transition: opacity .1s linear;
        }

        &__spinner {
            height: 100%;
        }
    }

    .no-items {
        &._empty-search {
            display: none !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserLocation.vue